module.exports = __webpack_public_path__ + "static/media/LP-Desk_PaollaIvete.89bb720b.png";